export const defaultSEO = {
  title: "Dominion Engineering - Excellence in Engineering Solutions",
  description:
    "Leading provider of engineering solutions for infrastructure, oil & gas, construction, and industrial projects In India.",
  keywords:
    "engineering, construction, infrastructure, oil and gas, industrial projects, dominion",
  authors: [
    {
      name: "Dominion Engineering",
      url: "https://dominionengg.com",
    },
  ],
  image: "/logo512.png",
  sitename: "Dominion Engineering",
  type: "website",
  locale: "en_US",
  gtmid: "GTM-NTL3KDZW",
  faviconurl: "/favicon.ico",
  og: {
    url: "https://dominionengg.com",
    title: "Dominion Engineering - Excellence in Engineering Solutions",
    description:
      "Specializing in infrastructure, oil & gas, and construction projects.",
    image: "/logo512.png",
  },
};

export const pageSEO = {
  home: {
    ...defaultSEO,
    title: "Dominion Engineering",
    description:
      "Transform your vision into reality with Dominion Engineering's comprehensive engineering and construction solutions.",
    keywords:
      "engineering solutions, construction services, infrastructure engineering, oil and gas solutions, civil engineering, industrial engineering, sustainable engineering, innovative construction, engineering expertise",
  },
  nav: {
    title: "Dominion Engineering",
    description:
      "Explore innovative solutions in engineering and construction.",
    keywords:
      "engineering navigation, construction services, infrastructure, oil and gas, civil engineering",
    og: {
      url: "https://dominionengg.com",
      title: "Dominion Engineering",
      description:
        "Explore innovative solutions in engineering and construction.",
    },
  },
  footer: {
    title: "Contact Dominion Engineering | Excellence in Engineering Solutions",
    description:
      "Get in touch with our team to discuss your engineering needs.",
    keywords:
      "footer contact, engineering services contact, about Dominion Engineering, engineering consultation",
    og: {
      url: "https://dominionengg.com/contact",
      title:
        "Contact Dominion Engineering | Excellence in Engineering Solutions",
      description:
        "Get in touch with our team to discuss your engineering needs.",
    },
  },

  about: {
    ...defaultSEO,
    title: "About Us - Dominion Engineering | Our Mission & Vision",
    description:
      "Learn about Dominion Engineering's journey, values, and commitment to excellence in engineering and construction.",
    keywords:
      "about Dominion Engineering, engineering company history, engineering expertise, company values",
    og: {
      url: "https://dominionengg.com/about",
      title: "About Us - Dominion Engineering | Our Story & Vision",
      description:
        "Explore our services in infrastructure, oil & gas, and construction projects.",
      image: "/logo512.png",
    },
  },

  services: {
    ...defaultSEO,
    title:
      "Our Services - Dominion Engineering | Comprehensive Engineering Solutions",
    description:
      "Explore our wide range of engineering services including infrastructure development, oil & gas projects, and construction solutions.",
    keywords:
      "engineering services, infrastructure development, oil and gas engineering, construction services, project management, structural engineering, industrial engineering, energy solutions, building design, civil construction, environmental engineering",
    og: {
      url: "https://dominionengg.com/services",
      title: "Our Services | Dominion Engineering - Engineering Solutions",
      description:
        "Explore our services in infrastructure, oil & gas, and construction projects.",
      image: "/logo512.png",
    },
  },

  projects: {
    ...defaultSEO,
    title: "Our Projects - Dominion Engineering | Portfolio of Excellence",
    description:
      "View our portfolio of successful engineering projects across infrastructure, oil & gas, and construction sectors.",
    keywords:
      "engineering projects, completed projects, project portfolio, engineering case studies, infrastructure projects, oil and gas projects, construction projects, civil engineering projects, successful engineering solutions, engineering project management",
  },

  contact: {
    ...defaultSEO,
    title: "Contact Us - Dominion Engineering | Get in Touch",
    description:
      "Connect with Dominion Engineering for your engineering and construction needs. Contact us today.",
    keywords:
      "contact engineering company, engineering consultation, project inquiry, engineering services contact, contact construction company, engineering team, engineering consulting, project management inquiry, building a project",
    og: {
      url: "https://dominionengg.com/contact",
      title:
        "Contact Dominion Engineering | Excellence in Engineering Solutions",
      description:
        "Get in touch with our team to discuss your engineering needs.",
      image: "/logo512.png",
    },
  },
};
